import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitCallback = (data) => api.post("/callbacks", data).then((r) => r.data);
export const submitOrder = (data) => api.post("/contact-orders", data).then((r) => r.data);
export const getLeads = () => api.get("/admin/leads").then((r) => r.data);
